import { CalendarBanner } from '../../types/banner';

export const bannerPresets: CalendarBanner[] = [
  {
    id: 'indigo-waves',
    name: 'Indigo Waves',
    color: '#EEF2FF',
    textColor: '#4F46E5',
    pattern: 'waves'
  },
  {
    id: 'emerald-dots',
    name: 'Emerald Dots',
    color: '#ECFDF5',
    textColor: '#059669',
    pattern: 'dots'
  },
  {
    id: 'sunset-glow',
    name: 'Sunset Glow',
    color: '#FFF7ED',
    textColor: '#EA580C',
    pattern: 'checkerboard'
  },
  {
    id: 'rose-garden',
    name: 'Rose Garden',
    color: '#FFF1F2',
    textColor: '#E11D48',
    pattern: 'honeycomb'
  },
  {
    id: 'amber-sunset',
    name: 'Amber Sunset',
    color: '#FFFBEB',
    textColor: '#D97706',
    pattern: 'topography'
  },
  {
    id: 'violet-night',
    name: 'Violet Night',
    color: '#FAF5FF',
    textColor: '#9333EA',
    pattern: 'circuit'
  },
  {
    id: 'arctic-frost',
    name: 'Arctic Frost',
    color: '#F0F9FF',
    textColor: '#0369A1',
    pattern: 'triangles'
  },
  {
    id: 'sage-meadow',
    name: 'Sage Meadow',
    color: '#ECFDF5',
    textColor: '#15803D',
    pattern: 'honeycomb'
  },
  {
    id: 'ocean-breeze',
    name: 'Ocean Breeze',
    color: '#ECFEFF',
    textColor: '#0891B2',
    pattern: 'waves'
  },
  {
    id: 'golden-hour',
    name: 'Golden Hour',
    color: '#FEF3C7',
    textColor: '#F59E0B',
    pattern: 'dots'
  },
  {
    id: 'lavender-dream',
    name: 'Lavender Dream',
    color: '#F5F3FF',
    textColor: '#7C3AED',
    pattern: 'dots'
  },
  {
    id: 'coral-reef',
    name: 'Coral Reef',
    color: '#FFF7ED',
    textColor: '#F97316',
    pattern: 'waves'
  },
  {
    id: 'mint-fresh',
    name: 'Mint Fresh',
    color: '#F0FDF4',
    textColor: '#16A34A',
    pattern: 'grid'
  },
  {
    id: 'ruby-glow',
    name: 'Ruby Glow',
    color: '#FEF2F2',
    textColor: '#DC2626',
    pattern: 'topography'
  },
  {
    id: 'sky-blue',
    name: 'Sky Blue',
    color: '#EFF6FF',
    textColor: '#2563EB',
    pattern: 'circles'
  },
  {
    id: 'forest-green',
    name: 'Forest Green',
    color: '#F0FDF4',
    textColor: '#166534',
    pattern: 'diagonal'
  }
];

// Get a random banner preset
export function getRandomBanner(): CalendarBanner {
  return bannerPresets[Math.floor(Math.random() * bannerPresets.length)];
}

// Get default banner
export function getDefaultBanner(): CalendarBanner {
  return bannerPresets[0];
}